import React from 'react';

export default function(size=32, style={}) {
  return (
    <svg width={size} height={size} style={style} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 160" shapeRendering="crispEdges">
      <path fill={style.fill || "#200535"} opacity={style.opacity || ".09"}
            d="M125 130v-5h-5v-5h-5v-5H45v5h-5v5h-5v5h-5v15h5v5h5v5h5v5h70v-5h5v-5h5v-5h5v-15z" fillRule="evenodd"/>
    </svg>
  )
}


// WEBPACK FOOTER //
// ./src/battle/svg-getters/CombatantShadow.js